import type { BaseStore, UseSelectorFunction } from './base';
import { useSelector as _useSelector, baseCreateStore, useDispatch } from './base';
import authentication from './reducers/authentication';
import core from './reducers/core';
import flight from './reducers/flight';
import hotel, { createListener as createHotelListener } from './reducers/hotel/index';
import loyalty from './reducers/loyalty';
import shoppingCart from './reducers/shoppingCart';
import type { StorefrontWithTenantId } from './reducers/storefrontConfig';
import storefrontConfig from './reducers/storefrontConfig';
import theme from './reducers/theme';
import longStay from './reducers/longStay';
import addon from './reducers/addon';
import rules from './reducers/rules';
export * as Authentication from './reducers/authentication';
export * as Core from './reducers/core';
export * as Flight from './reducers/flight';
export type { CriteriaForm } from './reducers/hotel/hotelSearch';
export * as Hotel from './reducers/hotel/index';
export * as Loyalty from './reducers/loyalty';
export * as ShoppingCart from './reducers/shoppingCart';
export type { PaymentOption } from './reducers/shoppingCart';
export * as StorefrontConfig from './reducers/storefrontConfig';
export type { StorefrontWithTenantId } from './reducers/storefrontConfig';
export * as Theme from './reducers/theme';
export * as Addon from './reducers/addon';
export * as Rules from './reducers/rules';
export { useDispatch };
const reducer = {
  authentication,
  hotel,
  shoppingCart,
  theme,
  loyalty,
  core,
  storefrontConfig,
  flight,
  longStay,
  addon,
  rules
};
export type RootState = { [K in keyof typeof reducer]: ReturnType<(typeof reducer)[K]> };
export type Store = BaseStore<RootState>;
export const createStore = (args?: {
  basePath: string;
  storefront?: StorefrontWithTenantId;
}): Store => baseCreateStore<RootState>({
  reducer,
  preloadedState: {
    core: {
      basePath: args?.basePath
    },
    storefrontConfig: {
      storefront: args?.storefront
    },
    authentication: {
      b2c: true
    }
  },
  listeners: [createHotelListener()]
});
export const useSelector = _useSelector as UseSelectorFunction<RootState>;